import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installGlobalErrorHandlers } from "@/lib/clientLog";

// Global error telemetry — ships window.onerror + unhandledrejection events to
// /api/client-log so admins can debug crashes via /admin/logs.
installGlobalErrorHandlers();

// Optional Sentry init — no-op when REACT_APP_SENTRY_DSN is unset.
if (process.env.REACT_APP_SENTRY_DSN) {
  // Lazy-load so the vendor chunk only ships when Sentry is actually enabled.
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENV || "production",
      release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_RATE || "0.1"),
      sendDefaultPii: false,
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
